import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormPreviewService } from '@configuration/shared/services/form-preview.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

// "Refresh the preview after any save anywhere in the configuration panel":
// rather than wiring every tab's save path, watch the HTTP layer for a
// successful write to any resource the previewed forms are
// built from (settings, hiring firm + logo, pages copy, question sets and
// their questions, relationships, lead types) and nudge the preview tab.
@Injectable()
export class PreviewRefreshInterceptor implements HttpInterceptor {
  public static readonly WRITE_METHODS = ['PATCH', 'POST', 'PUT', 'DELETE'];
  public static readonly WATCHED_RESOURCES =
    /\/api\/v[13]\/(settings|pages|hiring_firms|question_sets|questions|question_groups|reference_relationships|lead_types)(\/|\?|$)/;

  constructor(private readonly _preview: FormPreviewService) {}

  public intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!PreviewRefreshInterceptor.isWatched(request)) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse && event.ok) {
          this._preview.notifyChanged();
        }
      })
    );
  }

  public static isWatched(request: HttpRequest<any>): boolean {
    return (
      PreviewRefreshInterceptor.WRITE_METHODS.includes(request.method) &&
      PreviewRefreshInterceptor.WATCHED_RESOURCES.test(request.url)
    );
  }
}
